import { SearchableSelect } from "@risalabs_frontend_org/oasis-ui-kit";
import { Button, SpinningLoader } from "risa-oasis-ui_v2";

interface ClientOption {
  value: string;
  label: string;
}

interface CredentialsConfigHeaderProps {
  baseClassName: string;
  isLoadingClient: boolean;
  clientOptions: ClientOption[];
  onClientChange: (option: any) => void;
  onAddCredentialClick: () => void;
  showAddCredential?: boolean;
}

/**
 * Renders the credentials configuration page header: the page title, the
 * client picker (or its loading state), and the "Add Credential" action.
 */
export const CredentialsConfigHeader = ({
  baseClassName,
  isLoadingClient,
  clientOptions,
  onClientChange,
  onAddCredentialClick,
  showAddCredential = false,
}: CredentialsConfigHeaderProps) => {
  return (
    <div
      className={`${baseClassName}-header flex items-center justify-between gap-2 border-b border-primaryGray-14 pb-2 text-h11 font-semibold`}
    >
      <div className={`${baseClassName}-header-title`}>
        Credentials Configuration
      </div>
      <div className="flex items-end gap-3">
        {isLoadingClient ? (
          <SpinningLoader />
        ) : (
          <div className={`${baseClassName}-header-searchable-card w-[300px]`}>
            <SearchableSelect
              id={`${baseClassName}-client-select`}
              label=""
              options={clientOptions}
              onOptionChange={onClientChange}
              placeholder="Select a client to view credentials"
              searchPlaceholder="Search clients"
            />
          </div>
        )}
        {showAddCredential && (
          <Button
            buttonType="primary"
            size="medium"
            disabled={false}
            onClick={onAddCredentialClick}
          >
            Add Credential
          </Button>
        )}
      </div>
    </div>
  );
};
